"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

export function init() {
    let $sliders = $('.js-image-slider');

    import('./slick.js').then(function() {
        $sliders.each(function() {
            let $slider = $(this);
            let $sliderWrapper = $slider.closest('.js-image-slider__wrapper');

            $slider.slick({
                dots: true, /*should always be true; hide with css (accessibility)*/
                arrows:true,
                slidesToShow: 1,
                infinite:false,
                speed: 500,
                cssEase: 'ease',
                prevArrow: $sliderWrapper.find('.js-image-slider__arrow-prev'),
                nextArrow: $sliderWrapper.find('.js-image-slider__arrow-next'),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            variableWidth: true,
                        }
                    }
                ]
            });

        });
    })
}